import { Message } from 'element-ui';
import axios from '~/common/plugins/axios.js'
export const state = () => ({
  sku: null,
  proCardMode:'detail', // detail 详情模式 list 列表模式
  skuIdNow:'',
  listTypeNow:1, //  聚合方式【1-型号 2-厂牌 3-类目 默认1】,
  caches:[], // 缓存
  searchList:[],
  pagination:{
    listName: "型号",
    current: 1,
    page_size: 20,
    total: 0
  },
  searchParams:{ // 缓存请求参数
    name:'',
    aggr:1,
    current:1,
    page_size:20
  }
})

const  listTypes = {
  '1':'型号',
  '2':'厂牌',
  '3':'类目'
}

const replaceAll = function(str,s1,s2){
  return str.replace(new RegExp(s1, "gm"), s2);
}

export const mutations = {
  set_sku (state,v) {
    state.sku = v
  },
  set_searchList (state,v) {
    state.searchList = v
  },
  set_pagination (state,v) {
    state.pagination = v
  },
  set_listTypeNow (state,v) {
    state.listTypeNow = v;
    // clear
    state.searchList = []
  },
  set_searchParams (state,v) {
    state.searchParams = v;
  },
  set_skuIdNow (state,v) {
    state.skuIdNow = v;
  },
  set_proCardMode (state,v) {
    state.proCardMode = v;
  },
  set_caches (state,v) {
    state.caches = v;
  },
  add_caches (state,v) {
    state.caches.push(v);
  },
}

export const actions = {
  async get_sku ({ commit },{ id }) {
    if(!id)return{};
    const sku = await axios.$get(`/rest/portal/product/v3/sku/${id}`)
    commit('set_sku',sku.data)
    return sku.data;
  },
  async get_skuparams ({ commit },{ id }) {
    // 测试id = 6296339
    const spuparams = await axios.$get(`/rest/portal/product/v3/parameters/sku/${id}`)
    // const spuparams = await axios.$get(`/rest/portal/product/v3/sku/parameters/6296339`)
    console.log(spuparams);
    if(spuparams.data) {
      return spuparams.data
    }else{
      return []
    }
    // return sku.data;
  },
  async get_sku_search ({ commit,state,rootState },params) {
    // console.log(state.listTypeNow);
    params.name = rootState.search.searchKey;
    if(state.listTypeNow === '2' || state.listTypeNow === '3'){
      if(params.name&&params.name.length<3 ||!params.name){
        commit('set_searchParams',{
          name:'',
          aggr:1,
          current:1,
          page_size:20
        });
        Message({
          message:'至少输入3个关键字以上，请重新搜索',
          type:'error',
          offset:240
        })
        return;
      }
    }
    // 搜索词为空 clear
    if(!params.name){
      commit('set_searchList',[]);
      commit('set_pagination',{
        listName: "型号",
        current: 1,
        page_size: 20,
        total: 0
      });
      commit('set_searchParams',{
        name:'',
        aggr:1,
        current:1,
        page_size:20
      });
    }else{
      // console.log(params);
      // let formData = new FormData();
      let res = {} // 返回结果
      // let useCache = false; // 是否使用了缓存的开关
      // commit('search/set_searchParams',params,{root: true}); // 调用其他模块的 mutations
      commit('set_searchParams',params);
      // commit('search/set_searchKey',params.name,{root: true}); // 已取消，只有搜索框可以set searchKey
      // let _cacheKey = state.listTypeNow;
      // for(let key in params){
      //   // _cacheKey += params[key]; // 缓存用key
      //   formData.append(key,params[key]);
      // }
      // 检测缓存是否存在 是否超时
      // let _heart = 20*1000; // 当前超时时间
      // state.caches.forEach(c => {
      //   // console.log(c)
      //   if(c.name === _cacheKey){
      //     // 有缓存 - 判断是否超时
      //     let _now = (new Date()).getTime() - c.ts;
      //     if(_now<=10*1000) {
      //       console.log('使用了缓存');
      //       res = {...c.data};
      //       useCache = true;
      //     }
      //   }
      // })
      res = await axios.$post(`/rest/portal/product/v3/sku_search`,params)
      let _list = Array.isArray(res.data.list) ? res.data.list : [];
      console.log(params);
      // 高亮开发 - em标签已改为后台处理
      // if(params.aggr === '1'){
      //   _list.forEach(i => {
      //     console.log(i)
      //     i.spu_name = replaceAll(i.spu_name,params.name.toUpperCase(),`<em class="highlight-span">${params.name.toUpperCase()}</em>`)
      //   })
      //   console.log(_list)
      // }
      // pagination
      commit('set_searchList',_list);
      // console.log(res.data.pagination);
      let _pagination = res.data.pagination;
      _pagination['listName'] = listTypes[state.listTypeNow];
      commit('set_pagination',res.data.pagination);
      // 缓存数据
      // let _ts = (new Date()).getTime(); // 当前时间戳 心跳使用
      // let _cache = {
      //   name:_cacheKey,
      //   ts:_ts,
      //   data:res
      // }
      // commit('add_caches',_cache);
    }
  },
  async get_sku_search2 ({ commit,state },params) { // 带缓存
    // console.log(state.listTypeNow);
    // console.log(params);
    /**
     *  缓存写法说明
     *  1 预设缓存结果 let res = {}
     *  2 定义是否使用缓存的开关 let useCache = false; // 是否使用了缓存的开关
     *  3 制作缓存key唯一值 _cacheKey，唯一规则自定义
     *  4 检测缓存是否存在 是否超时 决定是否使用缓存
     *  5 缓存新的数据
     */
    if(state.listTypeNow === '2' || state.listTypeNow === '3'){
      if(params.name&&params.name.length<3 ||!params.name){
        commit('set_searchParams',{
          name:'',
          aggr:1,
          current:1,
          page_size:20
        });
        Message({
          message:'至少输入3个关键字以上，请重新搜索',
          type:'error',
          offset:240
        })
        return;
      }
    }
    // 搜索词为空 clear
    if(!params.name){
      commit('set_searchList',[]);
      commit('set_pagination',{
        listName: "型号",
        current: 1,
        page_size: 20,
        total: 0
      });
      commit('set_searchParams',{
        name:'',
        aggr:1,
        current:1,
        page_size:20
      });
    }else{
      // console.log(params);
      // let formData = new FormData();
      let res = {} // 返回结果
      let useCache = false; // 是否使用了缓存的开关
      commit('set_searchParams',params);
      let _cacheKey = state.listTypeNow;
      // for(let key in params){
      //   _cacheKey += params[key]; // 缓存用key
      //   formData.append(key,params[key]);
      // }
      // 检测缓存是否存在 是否超时
      let _heart = 20*1000; // 当前超时时间
      state.caches.forEach(c => {
        // console.log(c)
        if(c.name === _cacheKey){
          // 有缓存 - 判断是否超时
          let _now = (new Date()).getTime() - c.ts;
          if(_now<=10*1000) {
            console.log('使用了缓存');
            res = {...c.data};
            useCache = true;
          }
        }
      })

      if(!useCache) res = await axios.$post(`/rest/portal/product/v3/sku_search`,params)
      let _list = Array.isArray(res.data.list) ? res.data.list : [];
      // // pagination
      commit('set_searchList',_list);
      // console.log(res.data.pagination);
      let _pagination = res.data.pagination;
      _pagination['listName'] = listTypes[state.listTypeNow];
      commit('set_pagination',res.data.pagination);
      // 缓存新的数据
      let _ts = (new Date()).getTime(); // 当前时间戳 心跳使用
      let _cache = {
        name:_cacheKey,
        ts:_ts,
        data:res
      }
      commit('add_caches',_cache);
    }
  },
  async get_sku_query_admin({ commit,state },params) {
    const {code, data} = await axios.$post(`rest/erp/product/v3/skutypes/query`,params)
    if(code!==200) return
    return Promise.resolve(data)
  }
}

export default {
	namespaced: true,
	state,
	actions,
	mutations
}
